"use client";

import { METRICS_EVENTS } from "@cede/types";
import { CompletedBadge } from "./CompletedBadge";
import { Button } from "@/components/ui/button";
import { useAuthenticationProvider } from "@/hooks/authentication/useAuthenticationProvider";
import { useMetricsEvents } from "@/hooks/data/useMetricsEvents";
import { useHubUser } from "@/hooks/user/useHubUser";
import { formatAddressForDisplay } from "@/utils/address";
import { Wallet } from "lucide-react";

export const ConnectWallet = () => {
  const { authenticated, hubUser, login } = useHubUser();
  const { identityProvider } = useAuthenticationProvider();
  const { trackEvent } = useMetricsEvents();

  if (authenticated && hubUser?.defiAddress) {
    return <CompletedBadge label={`Connected: ${formatAddressForDisplay(hubUser.defiAddress, identityProvider)}`} />;
  }

  const handleConnect = () => {
    trackEvent(METRICS_EVENTS.CONNECT_WALLET_OPEN, { source: "crypto-com-signup" });
    login();
  };

  return (
    <Button
      size="small"
      variant="secondary"
      rightIcon={<Wallet className="size-5 text-cede-primary" strokeWidth={2} />}
      onClick={handleConnect}
    >
      Connect Wallet
    </Button>
  );
};
